"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.filter.js");
require("core-js/modules/es.iterator.map.js");
var _lifehikesInitData = require("@/lifehikes-init-data");
var _user = require("@/api/user");
var _cookie = require("@/utils/cookie");
var _ga = require("@/utils/ga");
var _log = require("@/utils/log");
var _permission = _interopRequireDefault(require("@/utils/permission"));
var _index = _interopRequireDefault(require("@/directive/permission/index.js"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 权限判断函数
// 权限判断指令
var _default = exports.default = {
  props: {
    uuid: {
      type: String,
      default: ''
    },
    skillSet: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      raterSkillSet: [],
      scoringSkillSetList: _lifehikesInitData.scoringSkillSetList,
      listLoading: false
    };
  },
  created() {
    this.raterSkillSet = this.skillSet;
  },
  methods: {
    checkPermission: _permission.default,
    save() {
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      const email = (0, _cookie.getCookie)('EMAIL');
      // console.log('token', token)
      let newRaterSkillSet = _lifehikesInitData.scoringSkillSetList.filter(key => this.raterSkillSet.includes(key.val)).map(p => p.val);
      console.info('-------newRaterSkillSet----------');
      console.info(newRaterSkillSet);
      (0, _user.updateUserProfile)(token, {
        uuid: this.uuid,
        scoringSkillSet: newRaterSkillSet
      }).then(response => {
        const data = response.data;
        // console.log('page-user-save', response)
        this.raterSkillSet = data.scoringSkillSet;
        (0, _log.displayPopupMessage)('User Scoring Skill Set has been updated successfully', 'success');
        (0, _ga.writeGaEvent)(this, 'User', 'Update Scoring Skill Set', email, `User Profile: ${data.uuid}`);
      }).catch(error => {
        (0, _log.showDebugLog)('Page-user-Save-Err', error);
        (0, _log.displayPopupMessage)(error, 'error');
      });
    }
  }
};